import React from 'react';
import Typography from '@mui/material/Typography';
import { withStyles } from '@mui/styles';
import { Box, Button } from "@mui/material";
import CardContent from '@mui/material/CardContent';

import DashboardTemplate from "../components/templates/DashboardTemplate";
import MixpanelOnload from "../components/MixpanelOnload";

const useStyles = theme => ({
    expandableCardTitle: {
        fontSize: '21px',
        lineHeight: '24px',
        marginBottom: '8px',
    },
    expandableCardSubTitle: {
        fontSize: '14px',
        color: '#888888',
    },
    sectionTitle: {
        color: '#FFFFFF',
        fontSize: '1.5rem',
        padding: '10px',
    },
    sectionBox: {
        background: '#7c7b7b',
        borderRadius: '10px',
    }
});

class Billing extends React.Component {
    constructor() {
        super();
        this.state = {
            invoices: []
        }
    }

    prependItems = () => {
        return <div>
            <Typography variant="h5" component="h2" align="center" marginTop="30px" marginBottom="30px">
                Billing History
            </Typography>
        </div>
    }

    componentDidMount() {
        fetch('/api/stripe/invoices', {
            method: "POST"
        })
            .then(res => {
                if (res.status !== 200) {
                    throw new Error('bad request');
                } else {
                    return res.json();
                }
            }).then(data => {
                this.setState({ invoices: data.invoices })
            }).catch(err => {
                console.log(err);
            })
    }

    render() {
        const { classes } = this.props;
        const { invoices } = this.state;
        // to grid layout?
        return (
            <DashboardTemplate prependItems={this.prependItems()} >
                {
                    invoices.map((invoice, i) => (
                        <CardContent style={{ width: '100%' }}>
                            <Box className={classes.sectionBox} marginTop="60px">
                                <h3 className={classes.sectionTitle}>Paid on:  {invoice.payment_date} | Receipt #{invoice.receipt_number}</h3>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <p>
                                        <label>Card: </label>
                                        {invoice.card.brand + ' - ' + invoice.card.last4}
                                    </p>
                                    <p>
                                        <label>Total Price: </label>
                                        {invoice.currency === 'usd' ? '$' : invoice.currency} {invoice.amount / 100}
                                    </p>
                                </Box>
                            </Box>
                            <Button
                                variant={"outlined"}
                                style={{
                                    backgroundColor: "transparent",
                                    color: "#FF2B01",
                                    borderColor: "#FF2B01",
                                }}
                                href={invoice.receipt_url}
                            >
                                View
                            </Button>
                        </CardContent>
                    ))
                }
                {
                    (invoices.length === 0) ?
                        <p>No Billing Data</p> :
                        <p></p>
                }
                <MixpanelOnload message="kiara-app.com/billing" />
            </DashboardTemplate >
        );
    }
}

export default withStyles(useStyles)(Billing);